// extracted by mini-css-extract-plugin
export default {"blogPost":"BlogPost_blogPost__hFvhK","title":"BlogPost_title__KNRnD","date":"BlogPost_date__Ov3H8","contentBody":"BlogPost_contentBody__tunbW","notFound":"BlogPost_notFound__+X7fQ"};